export function initNotes(): void {
  $(document).off('click', '.notes-button').on('click', '.notes-button', e => {
    const $btnEle = $(e.currentTarget);
    const botsProspectId = $(e.currentTarget).data('bots-prospect-id');
    const $toggledEle = $('.notes-' + botsProspectId)
    const isCandidatesTable = $btnEle.closest('#candidates-table').length > 0;

    if ($toggledEle.is(':visible')) {
      if (!isCandidatesTable) {
        $btnEle.removeClass('active');
      }

      if ($toggledEle.parent().parent().hasClass('all-candidates-note-form')) {
        $toggledEle.parent().hide()
      }
    } else {
      if (!isCandidatesTable) {
        $btnEle.addClass('active');
      }

      if ($toggledEle.parent().parent().hasClass('all-candidates-note-form')) {
        $toggledEle.parent().show()

        $toggledEle.hide()
      }
    }

    $toggledEle.toggle('fast');
  });

  $(document).on("ajax:success", ".write-note-form", event => {
    const value = event.target.querySelector('textarea[name="bots_prospect[notes]"]').value;
    const botsProspectId = event.target.id.replace("edit_bots_prospect_", "")
    const $toggledEle = $('.notes-' + botsProspectId)
    if ($toggledEle.parent().parent().hasClass('all-candidates-note-form')) {
      $toggledEle.parent().hide()
    }
    $toggledEle.hide()

    if(value) {
      $(".notes-button-" + botsProspectId).removeClass('active').addClass('created');
    } else {
      $(".notes-button-" + botsProspectId).removeClass('active').removeClass('created');
    }
  })
}
